export const Data = {
    "外链地址":"外链地址",
    "资料标题":"资料标题",
    "引用自":"引用自: ",
    "允许视频倍速":"允许视频倍速",
    "不允许视频倍速播放":"不允许视频倍速播放",
    "允许进度条拖拽":"允许进度条拖拽",
    "不允许进度条拖拽":"不允许进度条拖拽",
    "允许跳过互动答题":"允许跳过互动答题",
    "添加外链素材":"添加外链素材",
    "预览":"预览",
    "逻辑错误":"逻辑错误",
    "上传中当前进度":"上传中，当前进度:",
    "外链资源":"外链资源",
    "截至时间":"截至时间：",
    "时长":"时长",
    "需回复":"需回复",
    "人已读":"人已读",
    "人已参与":"人已参与",
    "直播参与人数":"直播参与人数",
    "平均在线时长":"平均在线时长",
    "完成回顾学习人数":"完成回顾学习人数",
    "最后访问时间":"最后访问时间:",
    "查阅":"查阅",
    "学习总时长":"学习总时长",
    "学习进度":"学习进度",
    "互动答题完成度":"互动答题完成度",
    "直播在线":"直播在线",
    "点我发弹幕":"点我发弹幕...",
    "发送弹幕/评论":"发送弹幕/评论",
    "很抱歉该视频被老师设置成不对外开放暂时无法预览":"很抱歉，该视频被老师设置成不对外开放，暂时无法预览",
    "当前老师设置为不允许跳过互动答题":"当前老师设置为不允许跳过互动答题",
    "前往答题":"前往答题",
    "当前老师设置为允许跳过互动答题":"当前老师设置为允许跳过互动答题",
    "跳过答题":"跳过答题",
    "作答保存成功":"作答保存成功",
    "主画面":"主画面",
    "批阅互动":"批阅互动",
    "个视频资源":"个视频资源",
    "资源类型":"资源类型",
}